let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2y34H")).then(() => parcelRequire('bhYx9'));